let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6rOp7")).then(() => parcelRequire('2McRM'));